<footer class="page-footer">
  <div class="container">
    <ul class="page-footer__menu">
      <li class="page-footer__menu__item">
        <a routerLink="/baza-wiedzy/polityka-prywatnosci" class="page-footer__menu__item__anchor">Polityka prywatności</a>
      </li>
      <li class="page-footer__menu__item">
        <a routerLink="/baza-wiedzy/polityka-prywatnosci" class="page-footer__menu__item__anchor">Polityka cookies</a>
      </li>
      <li class="page-footer__menu__item">
        <a *ngIf="isBrandGenerali$ | async" class="page-footer__menu__item__anchor"
           href="https://www.generali.pl/regulaminy" target="_blank" rel="noopener">Regulamin serwisu</a>
        <a *ngIf="isBrandProama$ | async" class="page-footer__menu__item__anchor" href="https://www.proama.pl/regulaminy/"
           target="_blank" rel="noopener">Regulamin serwisu</a>
      </li>
    </ul>
  </div>
</footer>
